import { render } from "./MainAuth.vue?vue&type=template&id=66208413&scoped=true"
import script from "./MainAuth.vue?vue&type=script&lang=js"
export * from "./MainAuth.vue?vue&type=script&lang=js"

import "./MainAuth.vue?vue&type=style&index=0&id=66208413&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66208413"]])

export default __exports__